import http from '../axios/http'

export function listSoftwareVersion() {
    const data = {
        dids: []
    }
    return http({
        url: '/api/softwareVersionManager/listSoftwareVersion',
        method: 'post',
        data
    })
}